import { Controller } from '@hotwired/stimulus';

interface SelectImageParams {
  params: {
    source: string;
  };
}

export default class extends Controller {
  static targets = ['input', 'image'];

  connect() {
    this.blurUnselectedImages();
  }

  selectImage({ params }: Event & SelectImageParams) {
    this.inputTarget.value = params.source;
    this.blurUnselectedImages();
  }

  blurUnselectedImages() {
    this.imageTargets.forEach((image: HTMLImageElement) => {
      if (image.getAttribute('data-image-picker-source-param') !== this.inputTarget.value) {
        image.classList.add('disabled');
      } else {
        image.classList.remove('disabled');
      }
    });
  }

  declare inputTarget: HTMLInputElement;

  declare imageTargets: HTMLImageElement[];
}
